import { useTranslation } from "react-i18next";
export default function AuthHeroSection() {
    const { t } = useTranslation();

    return (
        <>
            <div className="w-full bg-sidebar text-skyblue h-[100vh] hidden items-center justify-center flex-col xl:flex  gap-28 col-span-8" >

                <h1 className="text-[50px] w-[70%] text-center font-bold" >{t("authHeroSection.launchPrompt")}</h1>

               
            </div>
        </>
    )
}






